//Import all frontend scripts here

// header
import { headerInit } from './components/header';
import { loadMoreInit } from './components/load-more';
import { faqAccordion } from './components/faq-accordion';
import { storytellingInit } from './components/storytelling-parallax';
import { searchFilterPanel } from './components/search-filter-panel.js';
import { showToggle } from './components/show-toggle.js';
import { cookiesInit } from './components/cookies.js';
import { searchAlertInit } from './components/search-alert.js';

headerInit();
loadMoreInit();
faqAccordion();
storytellingInit();
searchFilterPanel();
showToggle();
cookiesInit();
searchAlertInit();
